import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../firebase';
import { LoadingState } from './ui';
import { useTheme } from '../theme';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const location = useLocation();
  const { isLoading: isThemeLoading } = useTheme();

  useEffect(() => {
    if (!auth) {
      setAuthChecked(true);
      setUser(null);
      return;
    }

    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setAuthChecked(true);
    });

    return unsub;
  }, []);

  if (!authChecked) {
    return <LoadingState title="Loading..." message="Checking authentication" />;
  }

  if (user && isThemeLoading) {
    return <LoadingState title="Loading..." message="Loading branding" />;
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location, reason: 'unauth' }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
